
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  color:var(--brand-white);
  width:100%;
  display:flex;
  height:100%;
  --dropdown-trigger-font-size:var(--fs-lg);
  --children-font-size:var(--fs-base);
  --outline-button--primary-padding--computed:0rem;
  --border-radius-pay-link:2rem;
  --menu-hover-droplet:url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDIwIDMyIj48cGF0aCBjbGFzcz0ic3ZnLWNzcC0xNzMiIGQ9Ik0xMC4wNDYgMGMwLjI1MyAwLjAwNCAwLjQ2NiAwLjE1NSAwLjU3NiAwLjM3bDAuMDM0IDAuMDY3YzAuMDc3IDAuMTk3IDAuMTIxIDAuNDEyIDAuMTcyIDAuNjE0IDAuMDcyIDAuMjgxIDAuMTc2IDAuNTU3IDAuMjc3IDAuODI5IDAuMjM4IDAuNjM3IDAuNTIgMS4yNTYgMC44MjYgMS44NjEgMC45NzUgMS45MjggMi4xNzUgMy43MzcgMy40MiA1LjQ5MiAxMC4wOTEgMTQuMjI0IDIuMDMzIDIyLjc2OC01LjMwNiAyMi43NjhzLTE1LjM5Ny04LjU0NC01LjMwNi0yMi43NjhjMS4yNDUtMS43NTUgMi40NDUtMy41NjQgMy40Mi01LjQ5MiAwLjMwNi0wLjYwNSAwLjU4OS0xLjIyNCAwLjgyNi0xLjg2MSAwLjEwMS0wLjI3MSAwLjIwNi0wLjU0NyAwLjI3Ny0wLjgyOSAwLjA1MS0wLjIwMiAwLjA5Ni0wLjQxNyAwLjE3My0wLjYxNGwwLjAzNC0wLjA2N2MwLjExLTAuMjE1IDAuMzIyLTAuMzY2IDAuNTc2LTAuMzd6TTQuMzUyIDE0LjUxMmMtMS44MzMgMy4xMzctMy4yNjUgNy42NTYtMC44MjQgMTEuNCAwLjA0MCAwLjA2MiAwLjE1NiAwLjIxMiAwLjE3IDAuMjMgMC41NTYgMC43MjkgMS4xMDMgMS4xNjMgMS41OTIgMS4zOTQgMC4zMDItMC4wNTcgMC41ODEtMC4xODMgMC43ODMtMC40MjggMC4yOTYtMC4zNTkgMC4yOTctMC44MTcgMC4xODMtMS4yNDctMi44MDYtMi43MTMtMy4zNzUtNi4xNDUtMS45MDMtMTEuMzQ4eiIgZmlsbD0iIzAwYTNlMCI+PC9wYXRoPjwvc3ZnPgo=');
}

:host([flip-alignment]) #dropdown-children{
    right:0;
  }

:host([pay-link]) [slot='parent-item'] a{
    border:none;
    color:var(--brand-primary-dark-blue);
    background-color:var(--brand-primary-blue);
    padding:var(--spacing-4) var(--spacing-8);
  }

@media (min-width: 1024px){

:host([pay-link]) [slot='parent-item'] a{
      margin-left:var(--spacing-2);
      transition:transform 0.3s ease-in-out
  }
    }

@media (min-width: 1280px){

:host([pay-link]) [slot='parent-item'] a{
      border-radius:var(--border-radius-pay-link);
      padding:var(--spacing-2) var(--spacing-6)
  }
    }

:host([pay-link]) [slot='parent-item'] a:hover{
      transform:scale(1.05);
    }

:host([pay-link]) .menu-item .menu-link{
      width:100%;
      text-align:center;
    }

@media (min-width: 1280px){

:host([pay-link]) .menu-item .menu-link{
        width:auto;
        text-align:left
    }
      }

:host([pay-link]) .menu-item::before,
    :host([pay-link]) .menu-item::after{
      display:none;
    }

.global-menu{
  width:100%;
  border-bottom:2px solid var(--brand-blue-300);
  font-family:var(--ff-display);
}

@media (min-width: 1280px){

.global-menu{
    border-bottom:0
}
  }

[slot='parent-item'] a,
  [slot='parent-item'] span{
    color:var(--brand-white);
    padding:var(--spacing-6) 0;
    display:block;
    text-decoration:none;
  }

@media (min-width: 1280px){

[slot='parent-item'] a,
  [slot='parent-item'] span{
      padding:var(--spacing-4) var(--spacing-2)
  }
    }

[slot='dropdown-children'] a{
    display:block;
    padding:var(--spacing-4) var(--spacing-8);
    position:relative;
    color:var(--brand-primary-dark-blue);
  }

[slot='dropdown-children'] a:hover{
    color:var(--brand-white);
    background-color:var(--brand-primary-dark-blue);
  }

@media (min-width: 1280px){

[slot='dropdown-children'] a:hover{
      background-color:transparent
  }
    }

@media (min-width: 1280px){
    [slot='dropdown-children'] a::after{
      content:'';
      position:absolute;
      pointer-events:none;
      background-color:var(--brand-primary-dark-blue);
      height:100%;
      left:0;
      top:0;
      transition-duration:0.425s;
      transition-property:width;
      width:0;
      z-index:-1;
    }
    [slot='dropdown-children'] a:hover::after{
      width:100%;
    }
  }

.menu-item{
  position:relative;
  width:100%;
  text-align:left;
  color:inherit;
  display:flex;
  align-items:center;
  font-size:var(--dropdown-trigger-font-size);
  font-weight:var(--fw-bold);
  cursor:pointer;
}

@media (min-width: 1280px){

.menu-item{
    font-weight:var(--fw-extrabold);
    width:auto;
    height:100%
}
  }

.menu-item outline-icon-baseline{
    transform:rotate(90deg);
  }

@media (min-width: 1280px){
    .menu-item::after{
      content:'';
      position:absolute;
      bottom:0px;
      left:0;
      width:0px;
      height:3px;
      transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
      transition-duration:150ms;
      opacity:0;
      background:var(--brand-bright-blue-900);
    }

    .menu-item::before{
      content:'';
      position:absolute;
      top:0;
      left:50%;
      width:10px;
      height:16px;
      background-image:var(--menu-hover-droplet);
      background-repeat:no-repeat;
      background-size:contain;
      transform:translateX(-50%);
      transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
      transition-duration:150ms;
      opacity:0;
    }
      .menu-item.menu-is-open:before, .menu-item .active-trail:before, .menu-item:hover:before{
        opacity:1;
      }
      .menu-item.menu-is-open::after, .menu-item .active-trail::after, .menu-item:hover::after{
        width:100%;
        opacity:1;
      }
  }

.dropdown-trigger{
  cursor:pointer;
  border:0;
  background:none;
  margin:0;
  flex-grow:1;
  display:flex;
  display:var(--menu-caret-display, flex);
  justify-content:flex-end;
}

@media (min-width: 1280px){

.dropdown-trigger{
    padding:0
}
  }

.dropdown-trigger.menu-is-open outline-icon-baseline{
    transform:rotate(-90deg);
  }

.icon{
  background:var(--brand-primary-blue);
  width:32px;
  height:32px;
  display:flex;
  align-items:center;
  justify-content:center;
}

.icon.btn.primary{
    color:var(--brand-white);
    color:var(--caret-icon-color, var(--brand-white));
  }

@media (min-width: 1280px){

.icon.btn.primary{
      background:transparent
  }
    }

.dropdown-children{
  text-align:left;
  font-size:var(--children-font-size);
  font-weight:var(--fw-bold);
  background:var(--brand-white);
  background:var(--dropdown-bg, var(--brand-white));
  z-index:50;
  box-shadow:0px 4px 30px rgba(0, 0, 0, 0.2);
  margin-bottom:var(--spacing-6);
  display:none;
}

.dropdown-children.is-open{
    display:block;
  }

@media (min-width: 1280px){

.dropdown-children{
    margin-bottom:0;
    position:absolute
}
  }

li{
  border-bottom:3px solid var(--brand-gray-400);
}

@media (min-width: 1280px){
    li:last-child{
      border-bottom:0;
    }
  }

@media (min-width: 1280px){
    :host([no-caret]) .dropdown-trigger{
      display:none;
    }
      :host([no-caret]) .menu-item::before{
        display:none;
      }
  }
`;